import { formatISO } from "date-fns";
import { EliminationExceptionReason } from "@common/types/domains/accounting/elimination";

interface EliminationExceptionsUrlOptions {
    startDate?: Date | string;
    endDate?: Date | string;
    workspaceId?: string;
    consolidationGroupId?: string;
    entityId?: number;
    accountCode?: number;
    reason?: EliminationExceptionReason;
}

function toDateParam(value: Date | string): string {
    return typeof value === "string"
        ? value
        : formatISO(value, { representation: "date" });
}

export function buildEliminationExceptionsUrl({
    startDate,
    endDate,
    workspaceId,
    consolidationGroupId,
    entityId,
    accountCode,
    reason,
}: EliminationExceptionsUrlOptions): string {
    const params = new URLSearchParams();

    if (startDate) {
        params.append("startDate", toDateParam(startDate));
    }
    if (endDate) {
        params.append("endDate", toDateParam(endDate));
    }
    if (workspaceId) {
        params.append("workspaceId", workspaceId);
    }
    if (consolidationGroupId) {
        params.append("consolidationGroupId", consolidationGroupId);
    }
    if (entityId !== undefined) {
        params.append("entityId", entityId.toString());
    }
    if (accountCode !== undefined) {
        params.append("accountCode", accountCode.toString());
    }
    if (reason) {
        params.append("reason", reason);
    }

    return `/accounting/elimination-exceptions?${params.toString()}`;
}
